import { useTheme, VStack, Icon, Box } from "native-base";
import { TextInputMask } from "react-native-masked-text";
import { FontAwesome } from "@expo/vector-icons";

interface IInput {
  label?: string;
  onChange: (e: any) => any;
  rest?: any;
  width: string | number;
}

export const InputDate = ({ name, label, width, value, setValue, ...rest }: any) => {
  const { colors } = useTheme();

  return (
    <VStack
      direction="row"
      alignItems="center"
      justifyContent="flex-start"
      w={width ?? "100%"}
    >
      <Box>
        <Icon
          as={FontAwesome}
          name="calendar"
          color={colors.primary[200]}
          size={4}
        />
      </Box>
      <Box ml={1}>
        <TextInputMask
          type="datetime"
          options={{
            format: "DD/MM/YYYY",
          }}
          value={value}
          includeRawValueInChangeText
          onChangeText={(inputValue) => {
            setValue(inputValue);
          }}
          placeholder="DD/MM/YYYY"
          style={{
            height: 30,
            borderWidth: 2,
            borderRadius: 10,
            borderColor: colors.primary[200],
            fontSize: 12,
            textAlign: "center",
            color: colors.primary[200],
            // backgroundColor: colors.primary[100],
          }}
          minWidth={width ?? 100}
          {...rest}
        />
      </Box>
    </VStack>
  );
};
